import {
  DcaBotsType,
  OnboardingDetailedStep,
  SignalsGroupsType,
  TradingMethodType,
} from "@shared/features/onboarding/types";
import {
  DASHBOARD_PATH,
  DCA_PUBLIC_BOTS_PATH,
  MARKETPLACE_PATH,
  ONBOARDING_CONNECT_EXCHANGE_PATH,
  ONBOARDING_CONNECT_EXTERNAL_ACCOUNT_PATH,
  ONBOARDING_COPY_DCA_BOT_PATH,
  ONBOARDING_DCA_BOT_OVERVIEW_PATH,
  ONBOARDING_FOLLOW_SIGNALS_GROUP_PATH,
  ONBOARDING_SELECT_EXCHANGE_PATH,
  ONBOARDING_SIGNALS_GROUP_OVERVIEW_PATH,
  ONBOARDING_TRADING_METHOD_PATH,
} from "common/constants";
import {
  TradingMethodCategory,
  TradingMethodCategoryValueType,
} from "analytics/Avo";
import { invert } from "lodash";

export const ONBOARDING_DETAILED_STEP_TO_PATH = {
  [OnboardingDetailedStep.SELECT_EXCHANGE]: ONBOARDING_SELECT_EXCHANGE_PATH,
  [OnboardingDetailedStep.CONNECT_EXCHANGE]: ONBOARDING_CONNECT_EXCHANGE_PATH,
  [OnboardingDetailedStep.TRADING_METHOD]: ONBOARDING_TRADING_METHOD_PATH,
  [OnboardingDetailedStep.COPY_DCA_BOT]: ONBOARDING_COPY_DCA_BOT_PATH,
  [OnboardingDetailedStep.FOLLOW_SIGNALS_GROUP]:
    ONBOARDING_FOLLOW_SIGNALS_GROUP_PATH,
  [OnboardingDetailedStep.CONNECT_EXTERNAL_ACCOUNT]:
    ONBOARDING_CONNECT_EXTERNAL_ACCOUNT_PATH,
  [OnboardingDetailedStep.SIGNALS_GROUP_OVERVIEW]:
    ONBOARDING_SIGNALS_GROUP_OVERVIEW_PATH,
  [OnboardingDetailedStep.DCA_BOT_OVERVIEW]: ONBOARDING_DCA_BOT_OVERVIEW_PATH,
  [OnboardingDetailedStep.SKIP]: DASHBOARD_PATH,
};

export const TRADING_METHOD_TO_FULL_LIST_PATH = {
  [TradingMethodType.DCA_BOT]: DCA_PUBLIC_BOTS_PATH,
  [TradingMethodType.SIGNALS_GROUP]: MARKETPLACE_PATH,
};

export const PATH_TO_DETAILED_STEP: Record<string, OnboardingDetailedStep> = {
  [ONBOARDING_SELECT_EXCHANGE_PATH]: OnboardingDetailedStep.SELECT_EXCHANGE,
  [ONBOARDING_CONNECT_EXCHANGE_PATH]: OnboardingDetailedStep.CONNECT_EXCHANGE,
  [ONBOARDING_TRADING_METHOD_PATH]: OnboardingDetailedStep.TRADING_METHOD,
  [ONBOARDING_FOLLOW_SIGNALS_GROUP_PATH]:
    OnboardingDetailedStep.FOLLOW_SIGNALS_GROUP,
  [ONBOARDING_COPY_DCA_BOT_PATH]: OnboardingDetailedStep.COPY_DCA_BOT,
  [ONBOARDING_CONNECT_EXTERNAL_ACCOUNT_PATH]:
    OnboardingDetailedStep.CONNECT_EXTERNAL_ACCOUNT,
  [ONBOARDING_DCA_BOT_OVERVIEW_PATH]: OnboardingDetailedStep.DCA_BOT_OVERVIEW,
  [ONBOARDING_SIGNALS_GROUP_OVERVIEW_PATH]:
    OnboardingDetailedStep.SIGNALS_GROUP_OVERVIEW,
};

export const SECTION_TYPE_TO_TRADING_CATEGORY: Record<
  DcaBotsType | SignalsGroupsType,
  TradingMethodCategoryValueType
> = {
  [DcaBotsType.TRENDING]: TradingMethodCategory.DCA_BOT_TRENDING,
  [DcaBotsType.LONG_RUNNING]: TradingMethodCategory.DCA_BOT_LONG_RUNNING,
  [DcaBotsType.HIGH_VOLUME]: TradingMethodCategory.DCA_BOT_HIGH_VOLUME,
  [SignalsGroupsType.MY_GROUPS]: TradingMethodCategory.SIGNALS_GROUP_MY_GROUP,
  [SignalsGroupsType.FREE_TRIAL]:
    TradingMethodCategory.SIGNALS_GROUP_FREE_TRIAL_GROUP,
  [SignalsGroupsType.FREE]: TradingMethodCategory.SIGNALS_GROUP_FREE_GROUP,
};

export const TRADING_CATEGORY_TO_CATEGORY_CONST: Record<
  TradingMethodCategoryValueType,
  number
> = {
  [TradingMethodCategory.DCA_BOT_TRENDING]: 1,
  [TradingMethodCategory.DCA_BOT_LONG_RUNNING]: 2,
  [TradingMethodCategory.DCA_BOT_HIGH_VOLUME]: 3,
  [TradingMethodCategory.SIGNALS_GROUP_MY_GROUP]: 4,
  [TradingMethodCategory.SIGNALS_GROUP_FREE_TRIAL_GROUP]: 5,
  [TradingMethodCategory.SIGNALS_GROUP_FREE_GROUP]: 6,
};

export const CATEGORY_CONST_TO_TRADING_CATEGORY = invert(
  TRADING_CATEGORY_TO_CATEGORY_CONST
) as Record<number, TradingMethodCategoryValueType>;
